import { createApp } from "vue";
import App from "./App.vue";
import { createVfm } from "vue-final-modal";
import router from "./router";
// Importar Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";
// añadimos tailwind css
import "./assets/css/tailwind.css";
// Importar Bootstrap JavaScript
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "@/assets/css/LineIcons.3.0.css";
import "@/assets/css/tiny-slider.css";
import "@/assets/css/glightbox.min.css";
// Importa el archivo de estilos
import "./assets/css/style.css";
// Importa el archivo de estilos
import "./assets/css/stylegeneral.css";
const app = createApp(App);
app.use(router);
app.use(createVfm());
app.mount("#app");
